/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Awaiting_PaymentInputs */

const en_queue_sos_awaiting_payment = /** @type {(inputs: Queue_Sos_Awaiting_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders waiting for payment`)
};

/**
* | output |
* | --- |
* | "Sales orders waiting for payment" |
*
* @param {Queue_Sos_Awaiting_PaymentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_awaiting_payment = /** @type {((inputs?: Queue_Sos_Awaiting_PaymentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Awaiting_PaymentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_awaiting_payment(inputs)
});